'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('path', {
                stroke: '#3F5060',
                strokeWidth: '2.14',
                d: 'M9.07 1.07h41.86v57.86H9.07z'
            }),
            _react2.default.createElement('path', {
                d: 'M28.902 9.709a1.65 1.65 0 0 0-1.646 1.644c0 1.184.698 2.759 1.435 4.223-.585 1.83-1.25 3.81-2.115 5.479h-.006c-1.72.676-3.25 1.187-4.116 1.883a.366.366 0 0 0-.034.029 1.673 1.673 0 0 0-.469 1.17 1.65 1.65 0 0 0 1.647 1.643c.445 0 .872-.162 1.177-.473a.365.365 0 0 0 .017-.023c.652-.776 1.463-2.254 2.173-3.59 0-.002.004-.003.005-.006 1.667-.655 3.426-1.329 5.128-1.723 1.158.957 2.916 1.615 4.304 1.615a1.65 1.65 0 0 0 1.647-1.644 1.65 1.65 0 0 0-1.647-1.643c-1.124 0-2.853.422-4.121.856a13.686 13.686 0 0 1-2.801-3.63c.491-1.525 1.069-3.058 1.069-4.166a1.65 1.65 0 0 0-1.647-1.644zm0 .73c.51 0 .915.405.915.914 0 .685-.381 1.9-.789 3.167-.562-1.219-1.04-2.446-1.04-3.167 0-.509.405-.913.914-.913zm.27 5.993a14.414 14.414 0 0 0 2.303 2.945c-1.326.341-2.636.82-3.91 1.313.642-1.37 1.146-2.839 1.606-4.258zm7.23 2.591c.51 0 .915.405.915.913a.908.908 0 0 1-.915.913c-.988 0-2.365-.485-3.372-1.141 1.163-.357 2.56-.685 3.372-.685zm-10.506 3.093c-.597 1.09-1.22 2.158-1.658 2.683a.884.884 0 0 1-.64.25.908.908 0 0 1-.915-.912.97.97 0 0 1 .251-.64c.528-.416 1.67-.875 2.962-1.38z',
                fill: '#A7F2EB',
                fillRule: 'nonzero'
            }),
            _react2.default.createElement('path', {
                d: 'M16.585 50.893h27.903M16.585 45.536h27.903',
                stroke: '#FFCF3F',
                strokeWidth: '2.14',
                strokeLinecap: 'square'
            }),
            _react2.default.createElement(
                'text',
                {
                    fontFamily: 'DINAlternate-Bold, DIN Alternate',
                    fontSize: '9.63',
                    fontWeight: 'bold',
                    fill: '#3F5060',
                    transform: 'translate(8)'
                },
                _react2.default.createElement(
                    'tspan',
                    {
                        x: '14.063',
                        y: '35.793'
                    },
                    'PDF'
                )
            )
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '60',
    viewBox: '0 0 60 60',
    xmlns: 'http://www.w3.org/2000/svg'
};

var DocumentIcon = function (_React$Component) {
    _inherits(DocumentIcon, _React$Component);

    function DocumentIcon() {
        _classCallCheck(this, DocumentIcon);

        return _possibleConstructorReturn(this, (DocumentIcon.__proto__ || Object.getPrototypeOf(DocumentIcon)).apply(this, arguments));
    }

    _createClass(DocumentIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return DocumentIcon;
}(_react2.default.Component);

exports.default = DocumentIcon;